import { render, staticRenderFns } from "./DashCard.vue?vue&type=template&id=2f308277&scoped=true"
import script from "./DashCard.vue?vue&type=script&lang=js"
export * from "./DashCard.vue?vue&type=script&lang=js"
import style0 from "./DashCard.vue?vue&type=style&index=0&id=2f308277&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f308277",
  null
  
)

export default component.exports